/**
 * ARIA grid helpers for task lists. Rows hold a single full-width cell; the cell uses
 * `display: contents`, so it changes semantics only, never layout.
 */
import type { HTMLAttributes, ReactNode } from 'react';

export function Cell({ children }: { children: ReactNode }) {
  return (
    <div role="gridcell" className="contents">
      {children}
    </div>
  );
}

/** A non-task line inside a grid (group header, "Add task", a note). */
export function GridRow({ children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div role="row" {...rest}>
      <Cell>{children}</Cell>
    </div>
  );
}
